import { render, staticRenderFns } from "./PaymentReceipt.vue?vue&type=template&id=087e9943&"
import script from "./PaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./PaymentReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports